










import { Vue, Component, Prop } from "vue-property-decorator";

import Speaker from "../../program/components/Speaker.vue";
import { UserProfile } from "../../../api/models/UserProfile";

@Component({
    components: { Speaker }
})
export default class UserInfoPopupSpeaker extends Vue {
    @Prop({default: null}) speaker: UserProfile|null;
}
